(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["moving-moments-gallery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mm-moments-gallery')) {
  customElements.define('mm-moments-gallery', class extends HTMLElement {
    connectedCallback() {
      this.scheduleLayout = () => {
        cancelAnimationFrame(this.layoutFrame);
        this.layoutFrame = requestAnimationFrame(() => this.fitCards());
      };
      this.onClick = (event) => {
        const opener = event.target.closest('[data-mm-open]');
        if (opener && this.contains(opener)) {
          const dialog = this.querySelector('#' + CSS.escape(opener.dataset.mmOpen));
          if (!dialog) return;
          this.querySelectorAll('dialog[open]').forEach((other) => other.close());
          this.lastOpener = opener;
          dialog.showModal();
          const video = dialog.querySelector('video');
          if (video) video.play().catch(() => {});
          return;
        }
        const close = event.target.closest('[data-mm-close]');
        if (close) close.closest('dialog').close();
        if (event.target.matches('dialog[data-mm-dialog]')) {
          const rect = event.target.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
        }
      };
      this.onClose = (event) => {
        if (!event.target.matches('dialog[data-mm-dialog]')) return;
        event.target.querySelectorAll('video').forEach((video) => video.pause());
        if (this.lastOpener?.isConnected) this.lastOpener.focus({preventScroll: true});
      };
      this.addEventListener('click', this.onClick);
      this.addEventListener('close', this.onClose, true);
      this.resizeObserver = new ResizeObserver(this.scheduleLayout);
      this.querySelectorAll('[data-mm-paper]').forEach((paper) => this.resizeObserver.observe(paper));
      window.addEventListener('resize', this.scheduleLayout, {passive: true});
      if (document.fonts) document.fonts.ready.then(() => { if (this.isConnected) this.scheduleLayout(); });
      this.scheduleLayout();
    }
    fitCards() {
      this.querySelectorAll('[data-mm-slot]').forEach((slot) => {
        const paper = slot.querySelector('[data-mm-paper]');
        const width = paper.offsetWidth;
        const height = paper.offsetHeight;
        if (!width || !height) return;
        const style = getComputedStyle(slot);
        const angle = (parseFloat(style.getPropertyValue('--mm-angle')) || 0) * Math.PI / 180;
        const offset = Math.abs(parseFloat(style.getPropertyValue('--mm-offset')) || 0);
        const rotatedWidth = Math.abs(width * Math.cos(angle)) + Math.abs(height * Math.sin(angle));
        const rotatedHeight = Math.abs(width * Math.sin(angle)) + Math.abs(height * Math.cos(angle));
        const scale = Math.min(1, Math.max(0.1, (slot.clientWidth - 14) / rotatedWidth));
        slot.style.setProperty('--mm-fit-scale', scale.toFixed(5));
        slot.style.setProperty('--mm-fit-height', Math.ceil(rotatedHeight * scale + 38 + offset * 2) + 'px');
        slot.setAttribute('data-mm-fitted', '');
      });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.layoutFrame);
      this.resizeObserver?.disconnect();
      window.removeEventListener('resize', this.scheduleLayout);
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('close', this.onClose, true);
      this.querySelectorAll('dialog[open]').forEach((dialog) => dialog.close());
      this.querySelectorAll('video').forEach((video) => video.pause());
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
